import * as types from 'Redux/types/creditPackages';

import yup from 'yup';
import { requestOptions } from 'Helpers/Graphql';

import creditPackagesQuery from 'Gql/queries/creditPackages.query';

import creditPackageBasicsFragment from 'Gql/fragments/creditPackage.basics';

export const fetchCreditPackages = (params = {}, req = null) => (dispatch) => {
    params = {
        ...params,
    };

    return requestOptions({
        req: req,
        type: types.FETCH_CREDITS_PACKAGES,
        onRetry: fetchCreditPackages,
        name: 'creditPackages',
        validationSchema: yup.object().shape({
            data: yup.object().shape({
                creditPackages: yup.array().of(
                    yup.object().shape({
                        id: yup.string().required(),
                        credits: yup.number().integer().required(),
                        discountPercentage: yup.number().integer().required(),
                        name: yup.string().required(),
                        price: yup.number().integer().required(),
                        worthPhotos: yup.number().integer().required()
                    }).required()
                ).ensure()
            }).required()
        }),
        params: params,
        requestParams: {},
        query: creditPackagesQuery
            .replace('%name%', 'creditPackages')
            .replace('%fields%', `
                ...creditPackageBasics
            `)
            .replace('%fragments%', `
                ${creditPackageBasicsFragment}
            `)
    });
};



// WEBPACK FOOTER //
// ./src/redux/actions/creditPackages.js